module.exports = __webpack_public_path__ + "img/logo.c9d5ec85.png";